const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);

/**
 * Reads a local answer draft without confusing an intentional empty string
 * with a missing draft. This matters when a learner clears a previously saved
 * answer: the empty draft must temporarily take precedence over the saved
 * value instead of causing it to reappear in the input.
 */
export const readAssessmentInputDraft = (inputStates, questionId) => {
  const key = String(questionId);
  if (hasOwn(inputStates, key)) {
    return { present: true, value: inputStates[key] ?? '' };
  }
  return { present: false, value: undefined };
};

export const resolveAssessmentInputValue = ({
  inputStates,
  questionId,
  storedValue,
}) => {
  const draft = readAssessmentInputDraft(inputStates, questionId);
  return draft.present ? draft.value : (storedValue ?? '');
};
